import React, {useEffect} from 'react';
import Advance_program_content from '../Component/Advance_program_content'

function Advance_program_page() {
    useEffect(()=>{
        document.title='Advance Program | InternsElite';
      },[]);
  return (
    <div>
    
    {/* -------------------Mobile View----------------------- */}
    <div className='Mobile_Advance_program_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid Mobile_background_color pt-4'>
            <div className='text-center py-5 Mobile_Main_text'>
                <h1 className='display-4  text-white'>InternsElite Advance Program</h1>
                <h3 className='text-white fs-6 pt-2'>Unleash your potential through our comprehensive programs, designed to propel your expertise to new heights </h3>
            </div>
        </div>
    </div>

    {/* ----------------------Desktop View------------------------- */}
    <div className='Advance_program_image d-none d-md-block mt-5'>
        <div className='container-fluid Advance_background_color pt-5'>
            <div className='text-center pt-5 mt-5 Advance_Main_text'>
                <h1 className='display-4 mt-5 pt-5 text-white'>InternsElite Advance Program</h1>
                <h3 className='text-white fs-4 pt-4 '>Unleash your potential through our comprehensive programs, designed to propel your expertise to new heights </h3>
            </div>
        </div>
    </div>
    <Advance_program_content/>
    </div>
  )
}

export default Advance_program_page
